import superagent from '@ott/superagent';
import checkAjaxError from '@ott/helper-check-ajax-error';

const metaDataStorage = {};

export default async function getMetaData(value) {
  if (!value) {
    return null;
  }

  if (metaDataStorage[value]) {
    return metaDataStorage[value];
  }

  const params = {
    searchText: value,
  };

  // если не число (id станции)
  if (Number.isNaN(value)) {
    params.mode = 'trans';
  }

  /* eslint-disable */
  try {
    var {
      body: {
        result: [station],
      },
    } = await superagent.get('/_railways/rzd/suggestStations').query(params).withCredentials();
  } catch (err) {
    return Promise.reject(checkAjaxError(err));
  }

  if (!station) {
    return null;
  }

  station.name = station.name.ru;

  metaDataStorage[station.trans] = station;
  metaDataStorage[station.id] = station;

  return station;
}
/* eslint-enable */
